import { race } from '../../shared/race.config'

const stamp = (iso: string) => new Date(iso).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')

function endIso() {
  return new Date(new Date(race.startsAt).getTime() + 2 * 3_600_000).toISOString()
}

const details = () =>
  `${race.tagline}\n\nStart: ${race.location.startArea}, ${race.location.venue}.\nDirections: ${race.location.directionsUrl}`

/** Google Calendar "add event" link. Works everywhere, including the demo preview. */
export function googleCalendarUrl() {
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: race.name,
    dates: `${stamp(race.startsAt)}/${stamp(endIso())}`,
    details: details(),
    location: `${race.location.venue}, ${race.location.areaLine}`,
    ctz: race.timezone,
  })
  return `https://calendar.google.com/calendar/render?${params}`
}

/** An .ics file for Apple Calendar / Outlook. */
export function icsDataUrl() {
  const esc = (s: string) => s.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/,/g, '\\,').replace(/;/g, '\\;')
  const ics = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    `PRODID:-//${race.name}//Registration//EN`,
    'BEGIN:VEVENT',
    `UID:race-${stamp(race.startsAt)}@bussewoods5k`,
    `DTSTAMP:${stamp(new Date().toISOString())}`,
    `DTSTART:${stamp(race.startsAt)}`,
    `DTEND:${stamp(endIso())}`,
    `SUMMARY:${esc(race.name)}`,
    `DESCRIPTION:${esc(details())}`,
    `LOCATION:${esc(`${race.location.venue}, ${race.location.areaLine}`)}`,
    `GEO:${race.location.lat};${race.location.lon}`,
    'END:VEVENT',
    'END:VCALENDAR',
  ].join('\r\n')
  return `data:text/calendar;charset=utf-8,${encodeURIComponent(ics)}`
}
